import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Grid, TextField } from "@material-ui/core";

const InputFieldAlt = ({ label, type, guid, min, max, maxlength, minlength, required, model, onUpdate, name, xs, fullWidth, passedValue, ...rest }) => {
    const { control } = useFormContext();

    useEffect(() => {
        control.setValue(name, passedValue);
    }, [passedValue])

    return (
        <Controller
            control={control}
            name={name}
            label={label}
            defaultValue=""
            rules={{ required: Boolean(required) }}
            render={() => {
                return (
                    <Grid 
                        item 
                        xs={xs ? xs : 3}
                    >
                        <TextField
                            InputProps={{ inputProps: { min: min, max: max, maxlength: maxlength, minlength: minlength, model: model, id: guid, guid: guid, autoComplete: "new-password" } }}
                            name={name}
                            label={label}
                            type={type}
                            fullWidth={fullWidth}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                            required={Boolean(required)}
                            error={Boolean(required && !passedValue)}
                            onChange={onUpdate}
                            value={passedValue}
                            {...rest}
                        />
                    </Grid>
                )
            }}
        >

        </Controller>
    )
}

export default InputFieldAlt;